import { api } from '../lib/api';

export type LinkToken = {
  _id: string;
  tenantId: string;
  status: 'active' | 'used' | 'expired' | 'revoked';
  createdBy: string;
  assignedRecruiter: string | null;
  source: string;
  expiresAt: string;
  usedAt: string | null;
  usedByRecruitId: string | null;
  createdAt: string;
  updatedAt: string;
};

export type CreateLinkResponse = {
  token: LinkToken;
  plaintext: string;
  url: string;
};

export async function listLinks(filter?: { status?: string }): Promise<{ tokens: LinkToken[] }> {
  const qs = filter?.status ? `?status=${encodeURIComponent(filter.status)}` : '';
  const { data } = await api.get(`/api/recruiting/links${qs}`);
  return data;
}

export async function createLink(body: {
  source?: string;
  expiresInDays?: number;
  assignedRecruiterId?: string;
}): Promise<CreateLinkResponse> {
  const { data } = await api.post('/api/recruiting/links', body);
  return data;
}

export async function revokeLink(id: string): Promise<{ token: LinkToken }> {
  const { data } = await api.patch(`/api/recruiting/links/${id}/revoke`);
  return data;
}
